import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=7f5dbc66&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"
import style0 from "./Tickets.vue?vue&type=style&index=0&id=7f5dbc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5dbc66",
  null
  
)

export default component.exports